import * as React from "react";

import "./suggestion-panel.scss";

import {cs}          from "@Common/react/chain-services";
import {UseState}    from "@Common/react/use-state";
import {Radio}       from "@Common/ui-components/heavy/common/design2/radio/radio";

import {ModalLayout} from "@Xpresso/routes/common/modal-layout/modal-layout";

export const SuggestionPanel = ({suggestion, onCancel, onSave}) => cs(
    ["saving", (_, next) => UseState({next})],
    ["useEntered", (_, next) => UseState({next})],
    ({saving, useEntered}) => ModalLayout({
        content: (
            <div className="suggestion-panel suggestion-panel-79s">
                <div className="title" xd-qa-type="label" xd-qa-name="Suggested Address">
                    Use Our Suggested Address?
                </div>
                <div className="sub-title"xd-qa-type="label" xd-qa-name="Suggested Address Subtitle">
                    The provided address has been slightly modified. If correct, please use the suggested address to ensure accuracy
                </div>

                <div className="table">
                    <div className="left">
                        {AddressPanel({
                            select: {
                                value: !useEntered.value,
                                onClick: () => useEntered.onChange(false),
                            },
                            label: "Suggested Address",
                            address: suggestion.suggestedAddress,
                        })}
                    </div>
                    <div className="left">
                        {AddressPanel({
                            select: {
                                value: useEntered.value,
                                onClick: () => useEntered.onChange(true),
                            },
                            label: "Entered Address",
                            address: suggestion.enteredAddress,
                        })}
                    </div>
                </div>
            </div>
        ),
        buttons: [
            {
                label: "Back",
                onClick: onCancel,
            },
            {
                label: saving.value ? "Saving..." : "Save",
                disabled: saving.value,
                primary: true,
                onClick: async () => {
                    saving.onChange(true);

                    try {
                        await onSave(useEntered.value ? suggestion.enteredAddress : suggestion.suggestedAddress);
                    } catch (e) {
                        // errorState.onChange(e);
                    } finally {
                        saving.onChange(false);
                    }
                },
            }
        ]
    }),
);

const AddressPanel = ({select, label, address}) => (
    <div className="address-panel" onClick={select.onClick}>
        <div className="header" xd-qa-type="label" xd-qa-name={label}>
            {Radio({
                selected: select.value,
                xdQaName: label,
            })}

            {label}
        </div>

        <div className="address">
            <div className="line" xd-qa-type="label" xd-qa-name="Address">
                {address.address}
            </div>

            {address.address2 && (
                <div className="line" xd-qa-type="label" xd-qa-name="Address 2">
                    {address.address2}
                </div>
            )}
            <div className="line" xd-qa-type="label" xd-qa-name="City State Zip">
                {address.city}, {address.state} {address.zip}
            </div>
        </div>
    </div>
);